module.exports = __webpack_public_path__ + "static/media/4.845206f3.mp3";